module.exports = __webpack_public_path__ + "static/media/02-banner-reabrimos-background-mobile@2x.aa255ee8.jpg";